<template>
  <div class="qyxxbgDiaLogBody">
    <div
      v-preventReClick
      style="
        position: absolute;
        right: 30px;
        top: 30px;
        font-size: 30px;
        color: #606266;
        cursor: pointer;
      "
      @click="back"
    >
      <i class="el-icon-circle-close" />
    </div>
    <div class="_title">
      <p class="_title_info">基本信息变更</p>
    </div>
    <div class="_yyzzPic">
      <el-upload
        class="upload-demo"
        :action="returnSaveFile"
        :on-remove="handleRemove"
        :before-upload="beforeUpload"
        :on-success="onSuccess"
        :show-file-list="false"
        :on-error="onError"
        :on-progress="onProgress"
        :data="imgInfomation"
        :headers="token"
      >
        <el-image
          v-loading="yyzzImg.loading"
          :src="yyzzImg.img"
          draggable="false"
          style="width: 196px; height: 227px"
          alt=""
        />
      </el-upload>
      <div
        v-show="yyzzImg.closeBox"
        v-preventReClick
        class="deleteUpload"
        @click="removeCurImg(item.name)"
      >
        <i class="el-icon-circle-close" />
      </div>
    </div>
    <p style="text-align: center">上传{{ dwxzWorld }}</p>
    <div class="_jbxxInfo">
      <div class="_jbxxTitle">单位基本信息</div>
      <div class="_jbxxBd">
        <el-form
          ref="DwForm1"
          :model="dwBgjlDtoFu"
          :rules="rules"
          label-position="right"
          class="_jbxxForm"
          label-width="140px"
        >
          <el-form-item v-if="labelFlag.dwmc" :label="dwmcName" prop="dwmc">
            <el-input
              v-model="dwBgjlDtoFu.dwmc"
              placeholder="请输入单位名称"
            />
          </el-form-item>
          <el-form-item label="单位性质:" prop="dwxz">
            <el-select
              v-model="dwBgjlDtoFu.dwxz"
              style="width: 100%"
              placeholder="请选择单位性质 "
              @change="dwxzChange"
            >
              <el-option
                v-for="(item, i) in dwxzList"
                :key="i"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="labelFlag.shtyxydm"
            :label="shtyxydmName"
            prop="shtyxydm"
          >
            <el-input
              v-model="dwBgjlDtoFu.shtyxydm"
              disabled
              placeholder="请输入统一信用代码"
            />
          </el-form-item>
          <el-form-item v-if="labelFlag.dwlx" :label="dwlxName" prop="dwlx">
            <el-select
              v-model="dwBgjlDtoFu.dwlx"
              style="width: 100%"
              placeholder="请选择单位类型"
            >
              <el-option
                v-for="(item, i) in dwlxList"
                :key="i"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="labelFlag.YyqxDate"
            :label="YyqxDateName"
            prop="yyqxKs"
          >
            <el-date-picker
              v-model="dwBgjlDtoFu.yyqxKs"
              type="date"
              value-format="yyyy-MM-dd"
              style="width: 100%"
              placeholder="选择日期"
            />
            至
            <el-date-picker
              v-model="dwBgjlDtoFu.yyqxJs"
              type="date"
              value-format="yyyy-MM-dd"
              style="width: 100%"
              placeholder="选择日期"
              :picker-options="pickerOptions"
            />
          </el-form-item>
          <el-form-item v-if="labelFlag.clrq" :label="clrqName" prop="clrq">
            <el-date-picker
              v-model="dwBgjlDtoFu.clrq"
              style="width: 100%"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="请选择成立日期"
            />
          </el-form-item>
          <el-form-item
            v-if="labelFlag.zczb"
            class="zczbItem"
            :label="zczbName"
            prop="zczb"
            width="120px"
          >
            <el-input v-model="dwBgjlDtoFu.zczb" placeholder="请输入注册资本" />
            <el-select
              v-model="dwBgjlDtoFu.zczbDw"
              placeholder="请选择货币"
              @change="zczbChange"
            >
              <el-option
                v-for="(item, i) in djdwList"
                :key="i"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-if="labelFlag.frmc" :label="frmcName" prop="frmc">
            <el-input
              v-model="dwBgjlDtoFu.frmc"
              placeholder="请输入法人/经营者"
            />
          </el-form-item>
          <el-form-item label="发证机关:" prop="fzjg">
            <el-input
              v-model="dwBgjlDtoFu.fzjg"
              placeholder="请输入发证机关"
            />
          </el-form-item>
          <el-form-item v-if="labelFlag.zhxs" label="组成形式" prop="zhxs">
            <el-input
              v-model="dwBgjlDtoFu.zhxs"
              placeholder="请输入组成形式"
            />
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="_qtxxInfo">
      <div class="_qtxxTitle">单位其他信息</div>
      <div class="_qtxxBd">
        <el-form
          ref="DwForm2"
          :rules="rules"
          label-position="right"
          class="_qtxxForm"
          label-width="140px"
          :model="dwBgjlDtoFu"
        >
          <el-form-item v-if="labelFlag.dwzj" :label="dwzjName" prop="dwzj">
            <el-input
              v-model="dwBgjlDtoFu.dwzj"
              placeholder="请输入座机或手机号"
            />
          </el-form-item>
          <el-form-item
            v-if="labelFlag.cyrysl"
            :label="cyryslName"
            prop="cyrysl"
          >
            <el-input
              v-model="dwBgjlDtoFu.cyrysl"
              placeholder="请输入从业人员数量"
            />
          </el-form-item>
          <el-form-item
            v-if="labelFlag.gsgajg"
            :label="gsgajgName"
            prop="gsgajg"
          ><!--  -->
            <el-cascader
              v-model="gsgajg"
              style="width: 100%"
              placeholder="请选择行政区划"
              :props="props"
              @change="gsgajgChange"
            />
          </el-form-item>
          <el-form-item
            v-if="labelFlag.sjjyd"
            class="jydItem"
            :label="sjjydName"
            prop="sjjyd"
          >
            <el-input
              v-model="dwBgjlDtoFu.sjjyd"
              placeholder="请输入实际经营地"
            />
          </el-form-item>
          <el-form-item
            v-if="labelFlag.dwzs"
            style="width: 100%"
            :label="dwzsName"
            class="jydItem"
            prop="dwzs"
          >
            <el-input
              v-model="dwBgjlDtoFu.dwzs"
              placeholder="请输入单位住所"
            />
          </el-form-item>
          <el-form-item
            style="width: 100%"
            v-if="labelFlag.zcdqh"
            label="注册地区划:"
            prop="zcdqh"
          ><!--  -->
            <el-cascader
              v-model="zcdqh"
              style="width: 100%"
              placeholder="请选择注册地区划"
              :props="props"
              @change="zcdqhChange"
            />
          </el-form-item>
          <el-form-item
            v-if="labelFlag.jyfw"
            style="width: 100%"
            :label="jyfwName"
            prop="jyfw"
          >
            <el-input
              v-model="dwBgjlDtoFu.jyfw"
              type="textarea"
              :rows="3"
              resize="none"
              placeholder="请输入经营范围"
            />
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
// 获取接口地址
import {
  getXzqTree,
  getXzqTreeS
} from '@/assets/js/step2.js'
import {
  getkv,
  getToken,
  returnSaveFile,
  returnShowPic
} from '@/assets/js/common.js'
import { lengthValidate } from '@/assets/js/validate.js'
export default {
  props: {
    dwBgjlDto: Object
  },
  data() {
    // 自定义校验
    const numberValidator = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入'))
      } else if (
        /^[1-9]\d{0,12}(\.\d{1,2})?$|^0(\.\d{1,2})?$/.test(value) == false
      ) {
        callback(new Error('整数位最大长度13位,保留2位小数'))
      }
      if (!this.dwBgjlDtoFu.zczbDw) {
        callback(new Error('请选择货币'))
      }
      callback()
    }
    const peopleValidator = (rule, value, callback) => {
      if (/^\d{1,9}$/.test(value) == false) {
        callback(new Error('支持最长9位正整数'))
      }
      callback()
    }
    const phoneValidator = (rule, value, callback) => {
      const reg1 = /^(0\d{2,3}-\d{7,8})$/ // 座机
      const reg2 = /^1[3456789]\d{9}$/
      if (!reg1.test(value) && !reg2.test(value)) {
        callback(new Error('请输入正确的电话或手机号格式'))
      }
      callback()
    }
    const dateValidator = (rule, value, callback) => {
      if (!this.dwBgjlDtoFu.yyqxKs) {
        callback(new Error('请输入起始时间'))
      }
      if (!this.dwBgjlDtoFu.yyqxJs) {
        callback(new Error('请输入结束时间'))
      }
      callback()
    }
    const jgjiaoyan = (rule, value, callback) => {
      if (this.gsgajg.length == 0) {
        return callback(new Error('请选择行政区划'))
      } else {
        this.gsgajg.forEach((element) => {
          if (element == undefined) {
            return callback(new Error('请选择行政区划'))
          }
        })
        callback()
      }
    }
    const jgjiaoyanZcdqh = (rule, value, callback) => {
      if (this.zcdqh.length == 0) {
        return callback(new Error('请选择注册地区划'))
      } else {
        this.zcdqh.forEach((element) => {
          if (element == undefined) {
            return callback(new Error('请选择注册地区划'))
          }
        })
        callback()
      }
    }
    return {
      // 时间选择器的快捷选项
      pickerOptions: {
        shortcuts: [
          {
            text: '长期有效',
            onClick(picker) {
              const date = new Date('2099-12-31')
              picker.$emit('pick', date)
            }
          }
        ]
      },
      // 行政区划懒加载
      props: {
        lazy: true,
        lazyLoad(node, resolve) {
          const { level } = node
          setTimeout(() => {
            if (level == 0) {
              getXzqTree().then((res) => {
                const nodes = res.data.data.map((item) => ({
                  value: item.value,
                  label: item.label,
                  leaf: !item.leaf
                }))
                resolve(nodes)
              })
            } else {
              getXzqTreeS(node.value).then((res) => {
                const nodes = res.data.data.map((item) => ({
                  value: item.value,
                  label: item.label,
                  leaf: !item.leaf
                }))
                resolve(nodes)
              })
            }
          }, 500) // 解决同步调用接口无法回显的问题
        }
      },
      dwxzList: [], // 单位性质列表
      dwlxList: [], // 单位类型列表
      djdwList: [], // 价格单位列表
      gsgajg: [], // 行政区划绑定值
      zcdqh: [], // 注册地区划绑定值
      // 上传营业执照携带数据
      imgInfomation: {
        sbzjlx: 'yyzzSb'
      },
      // 上传图片携带的token
      token: {
        Authorization: getToken()
      },
      returnSaveFile: '', // 图片上传
      returnShowPic: '', // 图片回显前缀
      // 营业执照默认图片
      yyzzImg: {
        name: '营业执照',
        img: require('@/assets/img/yyzz.png'),
        closeBox: false,
        loading: false
      },
      rules: {
        dwmc: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 200)
            },
            trigger: ['blur', 'change']
          }
        ],
        dwxz: [
          { required: true, message: '请选择活动区域', trigger: 'change' }
        ],
        shtyxydm: [
          {
            required: true,
            message: '统一信用代码不能为空',
            trigger: 'change'
          }
        ],
        /* dwxz: [
          { required: true, message: "单位性质不能为空", trigger: "blur" },
        ], */
        dwlx: [
          { required: true, message: '单位类型不能为空', trigger: 'change' }
        ],
        ywlx: [
          { required: true, message: '业务类型不能为空', trigger: 'change' }
        ],
        yyqxKs: [
          { required: true, validator: dateValidator, trigger: 'change' }
        ],
        clrq: [
          { required: true, message: '成立日期不能为空', trigger: 'change' }
        ],
        zczb: [
          {
            required: true,
            validator: numberValidator,
            trigger: ['blur', 'change']
          }
        ],
        frmc: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 200)
            },
            trigger: 'change'
          }
        ],
        dwzj: [
          { required: true, validator: phoneValidator, trigger: 'change' }
        ],
        cyrysl: [
          {
            required: true,
            validator: peopleValidator,
            trigger: ['blur', 'change']
          }
        ],
        gsgajg: [{ required: true, validator: jgjiaoyan, trigger: 'change' }],
        zcdqh: [{ required: true, validator: jgjiaoyanZcdqh, trigger: 'change' }],
        sjjyd: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 580)
            },
            trigger: ['blur', 'change']
          }
        ],
        jyfw: [
          {
            required: true,
            message: '经营范围不能为空',
            trigger: ['blur', 'change']
          },
          {
            min: 1,
            max: 3000,
            message: '内容不能超过3000个字符',
            trigger: ['blur', 'change']
          }
        ],
        dwzs: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 600)
            },
            trigger: ['blur', 'change']
          }
        ],
        fzjg: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 255)
            },
            trigger: ['blur', 'change']
          }
        ],
        zhxs: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 100)
            },
            trigger: ['blur', 'change']
          }
        ]
      },
      // 控制显示字段
      labelFlag: {
        dwmc: true, // 单位名称
        shtyxydm: true, // 社会统一信用代码
        dwxz: '1', // 单位性质
        dwlx: true, // 单位类型
        dwzs: true, // 单位住所
        frmc: true, // 法人/经营者名称
        zczb: true, // 注册资本
        clrq: true, // 成立日期
        jyfw: true, // 经营范围
        dwzj: true, // 单位座机
        sjjyd: true, // 实际经营地
        cyrysl: true, // 从业人员数量
        YyqxDate: true, // 营业执照路径
        gsgajg: true,
        zcdqh: true,

      },
      // 不同状态显示字符
      dwxzWorld: '营业执照',
      dwmcName: '单位名称:',
      shtyxydmName: '统一社会信用代码:',
      dwlxName: '单位类型:',
      dwzsName: '单位住所:', //
      frmcName: '法人/经营者:', //
      zczbName: '注册资本:', //
      clrqName: '成立日期:', //
      jyfwName: '经营范围:', //
      dwzjName: '单位座机:', // 单位座机
      sjjydName: '实际经营地:', //
      cyryslName: '从业人员数量:', //
      YyqxDateName: '营业期限:', //
      gsgajgName: '行政区划:'
    }
  },
  computed: {
    dwBgjlDtoFu: {
      get() {
        return this.dwBgjlDto
      },
      set(val) {
        this.$emit('getdwBgjlDto', val)
      }
    }
  },
  watch: {
    dwBgjlDtoFu(newValue, oldValue) {
      /* 行政区划 */
      this.gsgajg = [newValue.province, newValue.city, newValue.county]
      /* 注册地区划*/
      this.zcdqh = [newValue.sjProvince, newValue.sjCity, newValue.sjCounty]
      /* 营业执照上传 */
      if (newValue.yyzzUrl != '' && newValue.yyzzUrl != null) {
        this.yyzzImg.img = this.returnShowPic + newValue.yyzzUrl
      }
      // 判断当前单位性质 展示对应的内容
      this.panduan(newValue.dwxz)
    }
  },
  created() {
    this.returnSaveFile = returnSaveFile() // 图片上传前缀
    this.returnShowPic = returnShowPic() // 图片回显前缀
  },
  mounted() {
    /* 加载相关字典项 */
    getkv('yzd_dwxz').then((e) => {
      this.dwxzList = e.data.data
    })
    /* 单位类型 */
    getkv('yzd_dwlx').then((e) => {
      this.dwlxList = e.data.data
    })
    /* 单价单位 */
    getkv('yzd_xkzdjdw').then((e) => {
      this.djdwList = e.data.data
    })
  },
  methods: {
    lengthValidate,
    // 单位性质切换
    dwxzChange(val) {
      this.panduan(val) // 根据类型切换展示字段
    },
    // 注册资本切换
    zczbChange(val) {
      this.djdwList.filter((item, index) => {
        if (item.value == val) {
          this.dwBgjlDtoFu.zczbDwLabel = item.label
        }
      })
    },
    // 判断单位性质
    panduan(value) {
      switch (value) {
        case '1':
          this.dwxzWorld = '营业执照'
          this.labelFlag = {
            dwmc: true, // 单位名称
            shtyxydm: true, // 社会统一信用代码
            dwlx: true, // 单位类型
            dwzs: true, // 单位住所
            frmc: true, // 法人/经营者名称
            zczb: true, // 注册资本
            clrq: true, // 成立日期
            jyfw: true, // 经营范围
            dwzj: true, // 单位座机
            sjjyd: true, // 实际经营地
            cyrysl: true, // 从业人员数量
            YyqxDate: true, // 营业
            gsgajg: true,
            zcdqh: true
          }
          this.dwmcName = '单位名称:'
          this.shtyxydmName = '统一社会信用代码:'
          this.dwlxName = '单位类型:'
          this.dwzsName = '单位住所:' //
          this.frmcName = '法人/经营者:' //
          this.zczbName = '注册资本:' //
          this.clrqName = '成立日期:' //
          this.jyfwName = '经营范围:' //
          this.dwzjName = '单位座机:' // 单位座机
          this.sjjydName = '实际经营地:' //
          this.cyryslName = '从业人员数量:' //
          this.YyqxDateName = '营业期限:' //
          this.gsgajgName = '行政区划:'
          break
        case '7':
          this.dwxzWorld = '营业执照'
          this.labelFlag = {
            dwmc: true, // 单位名称
            shtyxydm: true, // 社会统一信用代码
            dwlx: true, // 单位类型
            dwzs: true, // 单位住所
            frmc: true, // 法人/经营者名称
            zczb: true, // 注册资本
            clrq: true, // 成立日期
            jyfw: true, // 经营范围
            dwzj: true, // 单位座机
            sjjyd: true, // 实际经营地
            cyrysl: true, // 从业人员数量
            YyqxDate: true, // 营业执照路径
            gsgajg: true,
            zcdqh: true,
          }
          this.dwmcName = '单位名称:'
          this.shtyxydmName = '统一社会信用代码:'
          this.dwlxName = '单位类型:'
          this.dwzsName = '单位住所:' //
          this.frmcName = '法人/经营者:' //
          this.zczbName = '注册资本:' //
          this.clrqName = '成立日期:' //
          this.jyfwName = '经营范围:' //
          this.dwzjName = '单位座机:' // 单位座机
          this.sjjydName = '实际经营地:' //
          this.cyryslName = '从业人员数量:' //
          this.YyqxDateName = '营业期限:' //
          this.gsgajgName = '行政区划:'
          break
        case '3':
          this.dwxzWorld = '社会团体法人/经营者登记证书'
          this.labelFlag = {
            dwmc: true, // 单位名称
            jyfw: true, // 经营范围
            dwzs: true, // 单位住所
            shtyxydm: true, // 社会统一信用代码
            sjjyd: true, // 实际经营地
            zczb: true, // 注册资本
            dwzj: true, // 单位座机
            gsgajg: true,
            zcdqh: true,
            YyqxDate: true, // 营业执照路径
            clrq: true // 成立日期
          }
          this.dwmcName = '名称:'
          this.jyfwName = '业务范围:' //
          this.dwzsName = '住所:' //
          this.shtyxydmName = '统一社会信用代码:'
          this.sjjydName = '活动地域:' //
          this.dwzjName = '单位座机:' // 单位座机
          this.zczbName = '注册资本:' //
          this.gsgajgName = '业务主管单位:'
          this.YyqxDateName = '有效期:' //
          this.clrqName = '发证日期:'
          break
        case '2':
          this.dwxzWorld = '事业单位法人/经营者证书'
          this.labelFlag = {
            dwmc: true, // 单位名称
            jyfw: true, // 经营范围
            dwzs: true, // 单位住所
            shtyxydm: true, // 社会统一信用代码
            zczb: true, // 注册资本
            gsgajg: true,
            zcdqh: true,
            dwzj: true, // 单位座机
            YyqxDate: true,
            clrq: true // 成立日期
          }
          this.dwmcName = '名称:'
          this.jyfwName = '宗旨和业务范围:' //
          this.dwzsName = '住所:' //
          this.shtyxydmName = '统一社会信用代码:'
          this.zczbName = '开办资金:' //
          this.dwzjName = '单位座机:' // 单位座机
          this.gsgajgName = '登记管理机关:'
          this.YyqxDateName = '有效期:' //
          this.clrqName = '发证日期:' //
          break
        case '5':
          this.dwxzWorld = '行政执法主体资格证'
          this.labelFlag = {
            dwmc: true, // 单位名称
            // sjjyd: true, //实际经营地
            dwzs: true, // 单位住所
            YyqxDate: true, // 营业执照路径
            shtyxydm: true, // 社会统一信用代码
            gsgajg: true,
            zcdqh: true,
            dwzj: true // 单位座机
          }
          this.dwmcName = '单位名称:'
          // this.sjjydName = "办公地址:"; //
          this.dwzsName = '办公地址:' //
          this.dwzjName = '单位座机:' // 单位座机
          this.YyqxDateName = '有效期:' //
          this.shtyxydmName = '证件编号:'
          this.gsgajgName = '行政区划:'
          break
        case '8':
          this.labelFlag = {
            dwmc: true, // 单位名称
            shtyxydm: true, // 社会统一信用代码
            // dwlx: true, //单位类型
            dwzs: true, // 单位住所
            frmc: true, // 法人/经营者名称
            zczb: true, // 注册资本
            clrq: true, // 成立日期
            jyfw: true, // 经营范围
            dwzj: true, // 单位座机
            sjjyd: true, // 实际经营地
            cyrysl: true, // 从业人员数量
            YyqxDate: true, // 营业
            gsgajg: true,
            zcdqh: true,
            zhxs: true
          }
          this.dwmcName = '字号名称:'
          this.shtyxydmName = '注册号:'
          // this.dwlxName = "单位类型:";
          this.dwzsName = '单位住所:' //
          this.frmcName = '经营者:' //
          this.zczbName = '注册资本:' //
          this.clrqName = '成立日期:' //
          this.jyfwName = '经营范围:' //
          this.dwzjName = '单位座机:' // 单位座机
          this.sjjydName = '实际经营地:' //
          this.cyryslName = '从业人员数量:' //
          this.YyqxDateName = '有效期限:' //
          this.gsgajgName = '行政区划:'
          break
        default:
          this.dwxzWorld = '营业执照'
          this.labelFlag = {
            shtyxydm: true, // 社会统一信用代码
            dwmc: true, // 单位名称
            dwzs: true, // 单位住所
            jyfw: true, // 经营范围
            dwzj: true, // 单位座机
            YyqxDate: true, // 营业执照路径
            clrq: true, // 成立日期
            gsgajg: true,
            zcdqh: true,
          }
          this.shtyxydmName = '编号:'
          this.dwmcName = '单位名称:'
          this.dwzsName = '单位地址:' //
          this.jyfwName = '许可范围:' //
          this.YyqxDateName = '有效期:' //
          this.dwzjName = '单位座机:' // 单位座机
          this.clrqName = '发证日期:' //
          this.gsgajgName = '行政区划:'
          break
      }
    },
    // 返回父页面
    back() {
      this.$bus.emit('exit')
    },
    // 校验 dialog3会调用
    validate() {
      var flag1 = false
      var flag2 = false
      this.$refs['DwForm1'].validate((valid) => {
        flag1 = valid
      })
      this.$refs['DwForm2'].validate((valid) => {
        flag2 = valid
      })
      if (!flag1) {
        // 如果单位基本信息的校验没通过  将滚动条滑到此处
        setTimeout(() => {
          var isError = document.getElementsByClassName('is-error')
          isError[0].querySelector('input').focus()
        }, 100)
        return false
      }
      if (!flag2) {
        // 将滚动条滑到此处
        setTimeout(() => {
          var isError = document.getElementsByClassName('is-error')
          isError[0].querySelector('input').focus()
        }, 100)
        return false
      }
      // 返回校验结果 子组件3回调使用
      return flag1 && flag2
    },
    // 行政区划切换
    gsgajgChange(value) {
      this.dwBgjlDtoFu.province = value[0]
      this.dwBgjlDtoFu.city = value[1]
      this.dwBgjlDtoFu.county = value[2]
    },
    zcdqhChange(value) {
      this.dwBgjlDtoFu.sjProvince = value[0]
      this.dwBgjlDtoFu.sjCity = value[1]
      this.dwBgjlDtoFu.sjCounty = value[2]
    },
    // 删除营业执照
    handleRemove(file, fileList) {
      this.yyzzImg.img = require('@/assets/img/yyzz.png')
    },
    // 上传前判断
    beforeUpload(file) {
      const fileType = ['image/jpeg', 'image/png', 'image/bmp']
      const isLt2M = file.size / 1024 < 500
      const typeTrue = fileType.includes(file.type)
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 500kb!')
      }
      if (!typeTrue) {
        this.$message.error('上传图片只能是 JPG/BMP/JPEG/PNG格式!')
      }
      return typeTrue && isLt2M
    },
    // 成功后数据回显
    onSuccess(response, file, fileList) {
      const data = response.data
      /* if (data.oneData) {
        for (let key in data.oneData) {
          this.dwBgjlDtoFu[key] = data.oneData[key];
        }
        this.$message.success("证件上传成功!");
      } else {
        this.$message.warning("证件上传成功,但无法识别!请手动填写!");
      } */
      /* 图片 */
      this.yyzzImg.img = this.returnShowPic + data.url
      this.dwBgjlDtoFu.yyzzUrl = data.url
      this.yyzzImg.loading = false
      /* 时间选择器赋值回显 */
      /* if (
        data.oneData.yyqxKs &&
        data.oneData.yyqxKs != "" &&
        data.oneData.yyqxKs != null
      ) {
        this.dwBgjlDtoFu.YyqxDate = [data.oneData.yyqxKs, data.oneData.yyqxJs];
      } */
      // this.gsgajg = [data.province, data.city, data.county];
    },
    onError() {
      this.$message.error('证件上传失败!')
    },
    onProgress(event, file, fileList) {
      this.yyzzImg.loading = true
    }
  }
}
</script>
<style lang="less" scoped>
.qyxxbgDiaLogBody {
  width: 90%;
  max-width: 1200px;
  margin: 20px auto 0px auto;
  display: flex;
  background-color: #fff;
  flex-direction: column;
  align-items: center;
  position: relative;
  ._title {
    width: 120px;
    margin-top: 50px;
    ._title_info {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 28px;
      margin: 0 auto;
    }
  }
  /deep/.el-upload-list {
    margin: 0;
    padding: 0;
    list-style: none;
    position: absolute;
    right: 0;
    top: -10px;
  }
  /deep/.deleteUpload {
    width: 25px;
    height: 25px;
    position: absolute;
    right: 0;
    top: 15px;
    cursor: pointer;
    color: white;
  }
  ._yyzzPic {
    margin-top: 40px;
    position: relative;
    /deep/.el-upload-list {
      margin: 0;
      padding: 0;
      list-style: none;
      position: absolute;
      right: 0;
      top: -10px;
    }
    /deep/.deleteUpload {
      width: 25px;
      height: 25px;
      position: absolute;
      right: 0;
      top: 15px;
      cursor: pointer;
      color: white;
    }
  }
  ._jbxxInfo {
    margin-top: 70px;
    width: 85%;
    ._jbxxTitle {
      width: 96px;
      height: 22px;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 22px;
    }
    ._jbxxBd {
      margin: 30px 0px;
      ._jbxxForm {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .el-form-item {
          margin-right: 0;
          width: 45%;
          /deep/.el-form-item__content {
            display: flex !important;
          }
        }
      }
    }
  }
  ._qtxxInfo {
    width: 85%;
    ._qtxxTitle {
      width: 96px;
      height: 22px;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 22px;
    }
    ._qtxxBd {
      margin: 30px 0px;
      ._qtxxForm {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .el-form-item {
          margin-right: 0;
          width: 45%;
          /deep/.el-form-item__content {
            display: flex !important;
          }
        }
      }
    }
  }
}
.qyxxbgDiaLogBody ._qtxxInfo ._qtxxBd ._qtxxForm {
  .el-form-item {
    &:nth-child(3),
    &:nth-child(4) {
      width: 100%;
    }
  }
}
</style>
